module.exports = {
  api: process.env.BUILD_ENV === 'development' ? 'https://awsapi.sportingglobe.com.au/api' : process.env.BUILD_ENV === 'staging' ? 'https://prod-api.sportingglobe.com.au/api' : 'https://prod-api.sportingglobe.com.au/api'
}